__turbopack_context__.v({
  "checkmark": "Checkbox-module-scss-module__y9NfaW__checkmark",
  "container": "Checkbox-module-scss-module__y9NfaW__container",
  "disabled": "Checkbox-module-scss-module__y9NfaW__disabled",
  "input": "Checkbox-module-scss-module__y9NfaW__input",
});
